// extracted by mini-css-extract-plugin
export default {"trade-count":"_1vGyi","tradeCount":"_1vGyi","download-icon":"_2HLAz","downloadIcon":"_2HLAz","resell-button-wrapper":"_2K14q","resellButtonWrapper":"_2K14q"};